import CreatePassword from './CreatePassword.container';

export default CreatePassword;
